import { User } from 'entities/user';
import * as React from 'react';
import { connect } from 'react-redux';
import { Actions, Selectors } from 'services/users';
import { State } from 'store';

interface OwnProps {
  id: string;
  prefix?: string;
  suffix?: string;
  placeholder?: string;
}

interface StateProps extends OwnProps {
  user: User;
}

interface DispatchProps {
  request: (id: string) => void;
}

export type Props = StateProps & DispatchProps;

export const UserLink: React.FC<Props> = props => {
  /* eslint-disable react-hooks/exhaustive-deps */
  React.useEffect(() => {
    if (!props.user) {
      props.request(props.id);
    }
  }, []);

  if (props.user) {
    return (
      <span>
        {props.prefix}
        <a href={`mailto:${props.user.email}`}>{props.user.name}</a>
        {props.suffix}
      </span>
    );
  }
  return <span>{props.placeholder ? props.placeholder : '-'}</span>;
};

export const mapState = (state: State, ownProps: OwnProps): StateProps => ({
  id: ownProps.id,
  user: Selectors.getEntity(state, ownProps.id),
});

const actions: DispatchProps = {
  request: Actions.requestGet,
};

export default connect(mapState, actions)(UserLink);
